import React from "react";
import { Select } from "../../controls";
import { useState } from "react";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";

const FoodSalesByCat = () => {
  const [fltLocaltion, setFltLocaltion] = useState(1);

  const handleLocation = (e) => {
    setFltLocaltion(e.target.value);
  };

  return (
    <>
      <Paper className="bs-primaryMD">
        <div className="flex items-center justify-between p-[10px] mb-[10px]">
          <div>
            <span className="w-[100%] text-[18px] font-medium text-gray-500 border-left uppercase">
              Food Sales By Category
            </span>
          </div>
          <Box
            className="flex gap-[10px]"
            sx={{ flexWrap: { xs: "wrap", md: "nowrap" } }}
          >
            <Select
              size="small"
              sx={{ minWidth: "200px" }}
              variant="outlined"
              value={fltLocaltion}
              onChange={handleLocation}
              options={[
                { id: 1, label: "Location 1" },
                { id: 2, label: "Location 2" },
                { id: 3, label: "Location 3" },
                { id: 4, label: "Location 4" },
                { id: 5, label: "Location 5" },
              ]}
            />
          </Box>
        </div>

        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell className="primary-color">Food By Category</TableCell>
              <TableCell className="primary-color" align="right">
                Total Amount
              </TableCell>
              <TableCell className="primary-color" align="right">
                Sale
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {records.map((item, i) => (
              <TableRow key={i}>
                <TableCell>{item.foodCat}</TableCell>
                <TableCell align="right">$ {item.amt}</TableCell>
                <TableCell align="right">{item.pct}</TableCell>
              </TableRow>
            ))}
            <TableRow
              sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
            >
              <TableCell className="font-medium">Overall Total: </TableCell>
              <TableCell className="font-medium" align="right">
                $0.00
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </Paper>
    </>
  );
};

export default FoodSalesByCat;

const records = [
  { foodCat: "Wet", amt: "604.21", pct: "10%" },
  { foodCat: "Toppers", amt: "604.21", pct: "10%" },
  { foodCat: "Row Alternative", amt: "604.21", pct: "10%" },
  { foodCat: "Kibble", amt: "604.21", pct: "10%" },
  { foodCat: "Frozen Row", amt: "604.21", pct: "10%" },
];
